export default {
    busqueda:{
        grafica:'',
        busqueda:false,
        regresar:false
    }
  };
